export const UNCATEGORIZED = 'Uncategorized';

export const DND_TYPES = {
  category: 'MEDIA_CATEGORY',
  image: 'MEDIA_IMAGE',
  images: 'MEDIA_IMAGES',
};

export const CATEGORY_DESCRIPTIONS = {
  [UNCATEGORIZED]: 'These photos will appear at the beginning of your album.',
  Scenery: '💡 Set the scene with photos of your venue, surroundings, and weather.',
  Details:
    '💡 It’s the little things! Highlighting rings, flowers, invitations, and more can help your wedding come alive on the page.',
  'Getting Ready':
    '💡 Pull back the curtain on those pre-wedding jitters with photos of you and loved ones getting ready.',
  'First Look':
    '💡 Consider including your reactions to each other’s wedding attire, even if you didn’t have a formal “first look.”',
  'Couple Portraits':
    '💡 Be sure to include some photos of you and your partner alone, both candid and posed.',
  'Wedding Party':
    '💡 If you involved a wedding party or friends in your celebration, consider including photos dedicated to them.',
  Family: '💡 Both candid and posed family photos can be fun to look back on for years to come.',
  Ceremony:
    '💡 Highlight special moments like the big kiss and celebratory walk back down the aisle. Throw in all your showstoppers!',
  'Cocktail Hour':
    '💡 Capture post-ceremony mingling with photos of guests, centerpieces, menus, and more.',
  Toasts:
    '💡 Chances are, some speeches brought on laughs and happy tears. Remember your best reactions here.',
  'Dance Floor':
    '💡 Include favorite first dance moments, but don’t forget to add photos of guests getting down, too.',
  Traditions:
    '💡 Include those special traditions most meaningful to you. These might be cultural or religious practices, like the tea ceremony or smashing of the glass.',
  Reception:
    '💡 Details like the dessert table, guestbook signing, and more can help bring to life the look and feel of your celebration.',
  'Send-Off':
    '💡 Whether you finished with a grand exit or quick peace out, end on a note that feels fitting.',
};
